'use client';

import { withCustomLinkComponent } from '@module/mdrt-org/shared/i18n/with-custom-link-component';
import {
  CarouselCard as CarouselCardBase,
  type CarouselCardProps as CarouselCardBaseProps,
} from '@shared/ui-components/card/carousel-card';

import { CarouselCardImage } from './carousel-card-image';

export type CarouselCardProps = Omit<CarouselCardBaseProps, 'LinkComponent'>;

export const CarouselCard = (props: CarouselCardProps) =>
  withCustomLinkComponent(CarouselCardBase, { ...props, ImageComponent: CarouselCardImage });
